import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import DesignAreaControlbox from '../../Components/DesignAreaControlbox/DesignAreaControlbox';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import {
    getSelectedDesignAreaProperties,
    getDesignDataForFilteredDesignAreas,
    getColors,
    isColoringDisabled,
} from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';

const mapStateToProps = state => {
    const {
        filteredDesignAreas,
        maxColorAmount: maxColorAmountSource,
        designProductionMethod,
        selectedDesignArea,
    } = getSelectedDesignAreaProperties(state);
    const hasDesign = getDesignDataForFilteredDesignAreas(state);
    const colorAmount = getColors(state).length;
    const maxColorAmount = parseInt(maxColorAmountSource);
    return {
        Component: DesignAreaControlbox,
        designAreas: filteredDesignAreas || [],
        designedAreas: hasDesign || {},
        valueProductionMethod: designProductionMethod,
        valueDesignArea: selectedDesignArea,
        colorAmount,
        maxColorAmount,
        hasAmountIndicatorWarning: Boolean(maxColorAmount && colorAmount > maxColorAmount),
        colorDisabled: isColoringDisabled(state),
        handleChangeDesignArea: ({ target: { value } }) => Services.designData.selectDesignArea(value),
        handleChangeProductionMethod: ({ target: { value } }) => {
            Services.designData.setDesignProductionMethod(value);
            Services.configurator.resolveCalculationErrors();
        },
    };
};

export default containerConnect(mapStateToProps);
